/* eslint-disable */
import girl1 from '../assets/svg/testimonials/girl1.svg'
import girl2 from '../assets/svg/testimonials/girl2.svg'
import girl3 from '../assets/svg/testimonials/girl3.svg'
import boy1 from '../assets/svg/testimonials/boy1.svg'
import boy2 from '../assets/svg/testimonials/boy2.svg'
import boy3 from '../assets/svg/testimonials/boy3.svg'



export const testimonialsData = [
    {
        id: 1,
        name: 'Coming Soon',
        title: 'Coming Soon',
        text: "Coming Soon.",
        image: boy2
    },
    {
        id: 2,
        name: 'Coming Soon',
        title: 'Coming Soon',
        text: "Coming Soon.",
        image: girl2
    },
    {
        id: 3,
        name: 'Coming Soon',
        title: 'Coming Soon',
        text: "Coming Soon",
        image: girl1
    },
    {
        id: 4,
        name: 'Coming Soon',
        title: 'Coming Soon',
        text: "Coming Soon",
        image: boy1
    },
    {
        id: 5,
        name: 'Coming Soon',
        title: 'Coming Soon',
        text: 'Coming Soon',
        image: girl3
    },
    {
        id: 6,
        name: 'Coming Soon',
        title: 'Coming Soont',
        text: "Coming Soon!",
        image: boy3
    }
]

